import api from "../utils/api";

const ROLES_BASE = "/api/authentication/roles";

export async function getRoles(params = {}) {
  const response = await api.get(ROLES_BASE, { params });
  return response.data;
}

export async function getRole(roleId) {
  const response = await api.get(`${ROLES_BASE}/${roleId}`);
  return response.data;
}

export async function createRole(payload) {
  const response = await api.post(ROLES_BASE, payload);
  return response.data;
}

export async function updateRole(roleId, payload) {
  const response = await api.put(`${ROLES_BASE}/${roleId}`, payload);
  return response.data;
}

export async function deleteRole(roleId) {
  const response = await api.delete(`${ROLES_BASE}/${roleId}`);
  return response.data;
}

export async function assignRolePermissions(roleId, permissionIds = []) {
  const response = await api.post(
    `${ROLES_BASE}/${roleId}/assign-permissions`,
    {
      permission_ids: permissionIds,
    },
  );

  return response.data;
}
